import React from 'react';

import { Text } from '~/components/blocks';

type Props = {
  active: boolean;
};

export const ActiveText = (props: Props) => {
  return (
    <Text whiteSpace="pre-wrap" wordBreak="break-all">
      {props.active ? <Text color="green">有効</Text> : <Text>無効</Text>}
    </Text>
  );
};
